import { clone } from 'remeda';

import { RecommendationsSettings } from '../../../../../types/Recommendations.js';
import { RecommendationSettingsType } from '../../RecommendationSettings.types.js';

const transformServerSettingsToUI = (
  settings: Partial<RecommendationsSettings>,
): Partial<RecommendationSettingsType> =>
  Object.entries(settings).reduce((acc, [key, value]) => {
    const transformed: RecommendationSettingsType & { [index: string]: any } =
      clone(acc);

    if (key === 'budgetReallocationLimits') {
      transformed.isBudgetLimited = !!value;
      transformed[key] = value as any;

      return transformed;
    }

    transformed[key] = value;

    return transformed;
  }, {} as RecommendationSettingsType);

export default transformServerSettingsToUI;
